<template>
  <nav class="navbar navbar-expand-lg bg-white sticky-top shadow-sm">
    <div class="container">
      <a class="navbar-brand d-flex align-items-center" href="#">
        <img src="../assets/bebebulle_logo.png" alt="Logo BebeBulle" width="32" height="32" class="me-2">
        <span class="fw-bold">Micro-crèche Bébé bulle</span>
      </a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar" aria-controls="mainNavbar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="mainNavbar">
        <ul class="navbar-nav ms-auto align-items-center">
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://www.facebook.com/Micro-cr%C3%A8che-B%C3%A9b%C3%A9-bulle-101714458750934/"
              target="_blank"
              rel="noopener noreferrer"
              title="Suivez-nous sur Facebook"
            >
              <i class="bi bi-facebook" style="font-size: 1.2rem;"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#qui-sommes-nous">Qui sommes-nous ?</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#ou-sommes-nous">Où sommes-nous ?</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#formulaire">Formulaire</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
// No more complex JavaScript logic needed here!
// Navigation is handled by HTML anchors and smooth scrolling.
// The "active state" is managed by the browser itself (or via CSS).
</script>

<style scoped>
/* We can add some styling to enhance the experience */
.navbar-brand {
  font-family: 'Poppins', sans-serif; /* A nice font for the logo */
}

.nav-link {
  font-weight: 500;
  transition: color 0.2s ease-in-out;
}

.nav-link:hover {
  color: #0d6efd; /* Bootstrap primary color */
}
</style>
